export interface ErrorMessageProps {
    message: string;
}

export const FormikErrorMessage = ({ message }: ErrorMessageProps) => {
    return (
        <p className="text-danger" style={{ margin: 0, padding: 0 }}>
            {message}
        </p>
    );
};
